import { TTBStatus } from '../../types/tryThenBuy';

export const TTB_FILTER_STATUS = [
  {
    text: 'Initialized',
    value: TTBStatus.INITIALIZED,
  },
  {
    text: 'Trial Coming',
    value: TTBStatus.TRIAL_COMING,
  },
  {
    text: 'Trial Started',
    value: TTBStatus.TRIAL_STARTED,
  },
  {
    text: 'Trial Half Done',
    value: TTBStatus.TRIAL_HALF_DONE,
  },
  {
    text: '2 Days Left in Trial',
    value: TTBStatus.TRIAL_2_DAYS_LEFT,
  },
  {
    text: '1 Day Left in Trial',
    value: TTBStatus.TRIAL_1_DAY_LEFT,
  },
  {
    text: 'Time To Decide',
    value: TTBStatus.TIME_TO_DECIDE,
  },
  {
    text: 'Last Chance',
    value: TTBStatus.LAST_CHANCE,
  },
  {
    text: 'Product Returning',
    value: TTBStatus.PRODUCT_RETURNING,
  },
  {
    text: 'Product Picked Up',
    value: TTBStatus.PRODUCT_PICKED_UP,
  },
  {
    text: 'Product Returned',
    value: TTBStatus.PRODUCT_RETURNED,
  },
  {
    text: 'Product Received',
    value: TTBStatus.PRODUCT_RECEIVED,
  },
  {
    text: 'Bought',
    value: TTBStatus.BOUGHT,
  },
  {
    text: 'Cancelled',
    value: TTBStatus.CANCELLED,
  },
  {
    text: 'Charged',
    value: TTBStatus.CHARGED,
  },
  {
    text: 'Mismatched Component',
    value: TTBStatus.MISMATCHED_COMPONENT,
  },
  {
    text: 'Mismatched Component Return Picked Up',
    value: TTBStatus.MISMATCHED_COMPONENT_RETURN_PICKED_UP,
  },
  {
    text: 'Mismatched Component Return Received',
    value: TTBStatus.MISMATCHED_COMPONENT_RETURN_RECEIVED,
  },
  {
    text: 'Product Returning To TM',
    value: TTBStatus.PRODUCT_RETURNING_TO_TM,
  },
  {
    text: 'Product Received By TM',
    value: TTBStatus.PRODUCT_RECEIVED_TO_TM,
  },
  {
    text: 'One Week Left To Forced Charge',
    value: TTBStatus.ONE_WEEK_LEFT_TO_FORCED_CHARGE,
  },
];
